import { NEW_RELIC_EVENTS } from '../../../constants';
import logNewRelicCustom from '../../../utils/logNewRelicCustom';

export default (set, get, dimensions) => {
  const setter = set(
    () => ({
      ...get(),
      stackDimensions: dimensions,
    }),
    false,
    { type: 'ADD_STACK_DIMENSIONS', payload: { stackDimensions: dimensions } },
  );
  logNewRelicCustom(NEW_RELIC_EVENTS.UPDATED_STACK_DIMENSIONS, dimensions);
  return setter;
};
